<template>
	<div>
		<b-modal
			ref="modalError"
			hide-footer
			static="true"
			:lazy="true"
			title="Error"
		>
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<b-modal
			ref="license_added"
			hide-footer
			static="true"
			:lazy="true"
			title="Account added"
		>
			<p class="my-4">A new account has been created.</p>
		</b-modal>
		<b-tabs pills card id="stat_view">

			<b-tab :title="$t('Stats.dashboard_tab')">
				<div class="dashboard_grid">
					<div class="summary_cell">
						{{ $t("Stats.projects_finished") }} {{ this.number_projects }}<br /> {{ $t("Stats.licenses") }} {{ this.number_licenses }}
					</div>
					<div class="cell connections_cell">
						<div id="canvas_box_connections_summary"></div>
					</div>
					<div class="cell features_cell">
						<div id="canvas_box_features_summary"></div>
					</div>
				</div>
			</b-tab>

			<b-tab :title="$t('Stats.connections_tab')">

				<div class="admin_controls">
					{{ $t("Stats.select_date") }}
					<b-form-select v-model="selected" :options="date_options" @change="updateCharts"></b-form-select>
				</div>

				<div id="canvas_box_connections"></div>

			</b-tab>

			<b-tab :title="$t('Stats.features_tab')">
				<div class="admin_controls">
					{{ $t("Stats.select_date") }}
					<b-form-select v-model="selected" :options="date_options" @change="updateCharts"></b-form-select>
				</div>

				<div id="canvas_box_features"></div>

			</b-tab>

<!--			<b-tab :title="$t('Stats.geolocation_tab')">-->

<!--			</b-tab>-->

			<!--			<b-tab :title="$t('Stats.tickets_tab')">-->
			<!--				<table>-->
			<!--					<tr>-->
			<!--						<th>-->
			<!--							<button id="btn2_email_address" class="sorting2 active" @click="sort2('email_address')">{{-->
			<!--								$t('Stats.email_col') }}-->
			<!--							</button>-->
			<!--						</th>-->
			<!--						<th>-->
			<!--							<button id="btn2_date_row" class="sorting2" @click="sort2('date_row')">{{-->
			<!--								$t('Stats.date_col') }}-->
			<!--							</button>-->
			<!--						</th>-->
			<!--						<th>-->
			<!--							<button id="btn2_state" class="sorting2" @click="sort2('state')">{{ $t('Stats.state_col')-->
			<!--								}}-->
			<!--							</button>-->
			<!--						</th>-->
			<!--					</tr>-->
			<!--					<tr v-for="ticket in this.tickets" :key="ticket.id">-->
			<!--						<td>{{ ticket.email_address }}</td>-->
			<!--						<td>{{ ticket.date_obj.toLocaleDateString($t('date_locale')) }}</td>-->
			<!--						<td v-if="enjoyb_admin" class="state_links">-->
			<!--							<button @click="update_state(ticket.id, 'open')"-->
			<!--									:class="{open:true, active: ticket.state=='open' }">{{ $t('Tickets.open') }}-->
			<!--							</button>-->
			<!--							<button @click="update_state(ticket.id, 'resolved')"-->
			<!--									:class="{resolved:true, active: ticket.state=='resolved' }">{{-->
			<!--								$t('Tickets.resolved') }}-->
			<!--							</button>-->
			<!--						</td>-->
			<!--						<td v-else class="state_static"><span-->
			<!--							:class="ticket.state">{{ $t('Tickets.' + ticket.state) }}</span></td>-->
			<!--					</tr>-->
			<!--				</table>-->

			<!--			</b-tab>-->

			<b-tab :title="$t('Stats.licenses_tab')">

				<form @submit.prevent="add_license">
					<div class=" input-group mb-3">

						<div class="input-group-prepend">
							<span class="input-group-text">{{ $t("Stats.add_license") }}</span>
						</div>
						<input type="email" class="form-control" placeholder="Email address" v-model="new_email" />
						<div class="input-group-append">
							<input type="submit" class="btn btn-outline-secondary" :value="$t('Stats.add_license_button')"/>
						</div>

					</div>
				</form>
				<table>
					<tr>
						<th>
							<button id="btn_name" class="sorting active" @click="sort('name')">{{
									$t('Stats.name_col')
								}}
							</button>
						</th>
						<th>
							<button id="btn_email_address" class="sorting" @click="sort('email_address')">{{
									$t('Stats.email_col')
								}}
							</button>
						</th>
						<th>
							<button id="btn_date_row" class="sorting" @click="sort('date_row')">{{
									$t('Stats.date_col')
								}}
							</button>
						</th>
					</tr>
					<tr v-for="license in this.licenses" :key="license.id">
						<td>{{ license.name }}</td>
						<td>{{ license.email_address }}</td>
						<td>{{ license.date_obj.toLocaleDateString($t('date_locale')) }}</td>
					</tr>
				</table>
			</b-tab>

		</b-tabs>

		<!--		<b-button class="btn_add_person">{{ $t('VideoPrivacy.exportAllButtonText')}}</b-button>-->
		<!--		<b-button @click="addPerson" class="btn_add_record">{{ $t('VideoPrivacy.addPersonButtonText')}}</b-button>-->

	</div>
</template>

<script>
import Navbar from "../ui/Navbar";
import Chart from "chart.js";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	components: {Navbar, lottie_error},
	name: "StatisticsAdmin",
	data() {
		return {
			tab_style: {
				color: "red",
			},
			selected: null,
			date_options: [],
			text_error: "",

			new_email: "",

			number_projects: 0,
			number_licenses: 0,

			licenses: [],
			tickets: [],
			sorting_attr: "name",
			sorting_order: 1,
			sorting_attr_ticket: "date_row",
			sorting_order_ticket: -1,

			enjoyb_admin: false,

			connections: null,
			labels_connections: [],

			chart_options: {},

			chart_features_options: {},
		};
	},
	activated() {
		// this.updateCharts();
	},
	created() {
		this.setOptions();
		this.get_first_date();
		let $this = this;
		EventBus.$on("setLanguage", function () {
			$this.setOptions();
			$this.get_first_date();
		});

		if (sessionStorage.getItem("usermail").includes("enjoyb.fr")) {
			this.enjoyb_admin = true;
		}
	},
	mounted() {
	},
	methods: {
		sort(key) {
			if (this.sorting_attr === key) { // if already sorting on this key, reverse order
				this.sorting_order = -this.sorting_order;
			}
			else {
				this.sorting_attr = key;
			}
			this.sortLicenses();
			this.updateHeaders();
		},
		sort2(key) {
			if (this.sorting_attr_ticket === key) { // if already sorting on this key, reverse order
				this.sorting_order_ticket = -this.sorting_order_ticket;
			}
			else {
				this.sorting_attr_ticket = key;
			}
			// this.sortTickets();
			this.updateHeaders();
		},
		sortLicenses() {
			let $attr = this.sorting_attr;
			let $order = this.sorting_order;

			this.licenses.sort(function (a, b) {
				let val1 = a[$attr].toString().toLowerCase();
				let val2 = b[$attr].toString().toLowerCase();
				if (val1 < val2) {
					return -$order;
				}
				if (val1 > val2) {
					return $order;
				}
				return 0;
			});
		},
		sortTickets() {
			let $attr = this.sorting_attr_ticket;
			let $order = this.sorting_order_ticket;

			this.tickets.sort(function (a, b) {
				let val1 = a[$attr].toString().toLowerCase();
				let val2 = b[$attr].toString().toLowerCase();
				if (val1 < val2) {
					return -$order;
				}
				if (val1 > val2) {
					return $order;
				}
				return 0;
			});
		},
		updateHeaders() {
			let headers = document.getElementsByClassName("sorting");
			let i;
			for (i = 0; i < headers.length; i++) {
				if (headers[i].id === "btn_" + this.sorting_attr) {
					if (!headers[i].classList.contains("active")) {
						headers[i].classList.add("active");
					}
				}
				else {
					headers[i].classList.remove("active");
				}
			}

			let headers2 = document.getElementsByClassName("sorting2");
			for (i = 0; i < headers2.length; i++) {
				if (headers2[i].id === "btn2_" + this.sorting_attr_ticket) {
					if (!headers2[i].classList.contains("active")) {
						headers2[i].classList.add("active");
					}
				}
				else {
					headers2[i].classList.remove("active");
				}
			}
		},
		add_license() {
			let bodyFormData = new FormData();
			bodyFormData.append("email", this.new_email);
			axios.post(BASE_URL + "/public/api/admin/add_license",
				bodyFormData,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).catch((error) => {
				// error
				console.log(error);
				this.$refs.modalError.show();
			}).then(response => {
				let data = response.data;
				// $this.get_tickets();
				this.$refs.license_added.show();
				this.get_licenses();
			});
		},
		// TODO move this to computed
		setOptions() {
			let $this = this;
			this.chart_options = {
				responsive: true,
				legend: {
					position: "bottom",
				},
				title: {
					display: true,
					text: $this.$root.$t("Stats.connections_title"),
				},
				scales: {
					xAxes: [
						{
							display: true,
							scaleLabel: {
								display: true,
								labelString: "Date",
							},
							ticks: {
								callback: function (value, index, values) {
									let d = new Date(value);
									return d.getDate() + " " + $this.$root.$t("months." + (d.getMonth() + 1));
								},
							},
						},
					],
					yAxes: [
						{
							display: true,
							ticks: {
								min: 0,
								precision: 0,
							},
							scaleLabel: {
								display: true,
								labelString: this.$root.$t("Stats.connections"),
							},
						},
					],
				},
			};

			this.chart_features_options = {
				responsive: true,
				legend: {
					position: "bottom",
				},
				title: {
					display: true,
					text: $this.$root.$t("Stats.features_title"),
				},
				scales: {
					xAxes: [
						{
							display: true,
							scaleLabel: {
								display: true,
								labelString: "Date",
							},
							ticks: {
								callback: function (value, index, values) {
									let d = new Date(value);
									return d.getDate() + " " + $this.$root.$t("months." + (d.getMonth() + 1));
								},
							},
						},
					],
					yAxes: [
						{
							display: true,
							ticks: {
								min: 0,
								precision: 0,
							},
							scaleLabel: {
								display: true,
								labelString: this.$root.$t("Stats.features"),
							},
						},
					],
				},
			};
		},

		createChartConnections(labels, dataset, summary = false) {
			let chart_data = {
				type: "bar",
				data: {
					labels: labels,
					datasets: [
						{
							label: this.$root.$t("Stats.connections"),
							backgroundColor: "#224B93",
							fill: false,
							// lineTension: 1,
							data: dataset,
						},
					],
				},
			};

			let container;
			if (summary) {
				container = document.getElementById("canvas_box_connections_summary");
			}
			else {
				container = document.getElementById("canvas_box_connections");
			}

			while (container.firstChild) {
				container.removeChild(container.lastChild);
			}
			const ctx = document.createElement("canvas"); // Create a <button> element
			container.appendChild(ctx);

			// const ctx = document.getElementById(chartId);
			const myChart = new Chart(ctx, {
				type: chart_data.type,
				data: chart_data.data,
				options: this.chart_options,
			});
		},

		createChartFeatures(labels, datasets, summary = false) {
			let chart_data = {
				type: "bar",
				data: {
					labels: labels,
					datasets: [
						{
							label: this.$root.$t("Stats.preview"),
							borderColor: "#BE9B05",
							backgroundColor: "#FCE500",
							borderWidth: 1,
							fill: false,
							data: datasets["preview"],
						},
						{
							label: this.$root.$t("Stats.finalisation"),
							backgroundColor: "#224B93",
							fill: false,
							data: datasets["finalisation"],
						},
						{
							label: this.$root.$t("Stats.cut"),
							borderColor: "#224B93",
							backgroundColor: "#257DD7",
							borderWidth: 1,
							fill: false,
							data: datasets["cut"],
						},
						{
							label: this.$root.$t("Stats.append"),
							borderColor: "#224B93",
							backgroundColor: "#AAAAAA",
							borderWidth: 1,
							fill: false,
							data: datasets["append"],
						},
						{
							label: this.$root.$t("Stats.subtitles"),
							borderColor: "#866E08",
							backgroundColor: "#BE9B05",
							borderWidth: 1,
							fill: false,
							data: datasets["subtitles"],
						},
					],
				},
			};

			let container;
			if (summary) {
				container = document.getElementById("canvas_box_features_summary");
			}
			else {
				container = document.getElementById("canvas_box_features");
			}

			while (container.firstChild) {
				container.removeChild(container.lastChild);
			}
			const ctx = document.createElement("canvas"); // Create a <button> element
			container.appendChild(ctx);

			// const ctx = document.getElementById(chartId);
			const myChart = new Chart(ctx, {
				type: chart_data.type,
				data: chart_data.data,
				options: this.chart_features_options,
			});
		},

		// Reload the charts
		updateCharts() {
			this.get_summary();
			this.get_licenses();
			// this.get_tickets();
			this.summary7days();
			if (this.selected === null) {
				this.last30days();
			}
			else {
				this.thisMonth(this.selected);
			}
		},

		last30days() {
			let end = new Date(Date.now());
			end.setHours(0);
			end.setMinutes(0);
			end.setSeconds(0);
			end.setMilliseconds(0);

			let start = new Date(end);
			start.setDate(end.getDate() - 30);

			this.getData(start, end);
		},

		summary7days() {
			let end = new Date(Date.now());
			end.setHours(0);
			end.setMinutes(0);
			end.setSeconds(0);
			end.setMilliseconds(0);

			let start = new Date(end);
			start.setDate(end.getDate() - 7);

			this.getData(start, end, true);
		},

		thisMonth(date) {
			let end = new Date(date);
			end.setMonth(end.getMonth() + 1);
			end.setDate(0);

			let start = new Date(end);
			start.setDate(1);

			this.getData(start, end);
		},
		toDateString(date) {
			// return date.toISOString().split("T")[0]
			let day = ("0" + date.getDate()).slice(-2);
			let month = ("0" + (date.getMonth() + 1)).slice(-2);
			let year = date.getFullYear().toString();

			return year + "-" + month + "-" + day;
		},
		optionFormat(date) {
			return this.$root.$t("months." + (date.getMonth() + 1)) + " " + date.getFullYear();
		},

		get_first_date() {
			let $this = this;
			axios.get(BASE_URL + "/public/api/admin/stats/firstdate", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let options = [];
				options.push({value: null, text: $this.$root.$t("Stats.last_month")});

				let first = new Date(response.data.datetime);
				let date = new Date(Date.now());

				// (false positive
				// eslint-disable-next-line no-unmodified-loop-condition
				while (date > first) {
					let start = new Date(date);
					start.setDate(1);
					start.setHours(0);
					start.setMinutes(0);
					start.setSeconds(0);
					start.setMilliseconds(0);

					options.push({value: start, text: $this.optionFormat(date)});
					date.setMonth(date.getMonth() - 1);
				}

				$this.date_options = options;

				$this.updateCharts();
			}).catch(error => {
				$this.text_error = this.$root.$t("Errors.error_detailed") + error;
				$this.$refs.modalError.show();
			});
		},
		getData(start, end, summary = false) {
			let $this = this;
			let datasets = {};
			let data = {};

			data["connection"] = {};
			data["preview"] = {};
			data["finalisation"] = {};
			data["cut"] = {};
			data["append"] = {};
			data["subtitles"] = {};

			datasets["connection"] = [];
			datasets["preview"] = [];
			datasets["finalisation"] = [];
			datasets["cut"] = [];
			datasets["append"] = [];
			datasets["subtitles"] = [];

			let date = new Date(start);
			let labels = [];

			// (false positive)
			// eslint-disable-next-line no-unmodified-loop-condition
			while (date < end) {
				date.setDate(date.getDate() + 1);
				let date_string = this.toDateString(date);
				labels.push(date_string);

				// Init all dates to zero
				data["connection"][date_string] = 0;
				data["preview"][date_string] = 0;
				data["finalisation"][date_string] = 0;
				data["cut"][date_string] = 0;
				data["append"][date_string] = 0;
				data["subtitles"][date_string] = 0;
			}

			axios.get(BASE_URL + "/public/api/admin/stats/data", {
				params: {"start": this.toDateString(start), "end": this.toDateString(end)},
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let events = response.data;
				events.forEach(function (event) {
					// let date = new Date(event.datetime);
					let date_string = event.datetime.split(" ")[0];

					if (data[event.key]) {
						data[event.key][date_string]++;
					}
				});

				// Populate datasets
				labels.forEach(function (date_label) {
					let obj_conn = {
						x: date_label,
						y: data["connection"][date_label],
					};

					let obj_preview = {
						x: date_label,
						y: data["preview"][date_label],
					};

					let obj_final = {
						x: date_label,
						y: data["finalisation"][date_label],
					};

					let obj_cut = {
						x: date_label,
						y: data["cut"][date_label],
					};

					let obj_append = {
						x: date_label,
						y: data["append"][date_label],
					};

					let obj_subtitles = {
						x: date_label,
						y: data["subtitles"][date_label],
					};

					datasets["connection"].push(obj_conn);
					datasets["preview"].push(obj_preview);
					datasets["finalisation"].push(obj_final);
					datasets["cut"].push(obj_cut);
					datasets["append"].push(obj_append);
					datasets["subtitles"].push(obj_subtitles);
				});

				$this.createChartConnections(labels, datasets["connection"], summary);
				$this.createChartFeatures(labels, datasets, summary);
			}).catch(error => {
				$this.text_error = error;
				$this.$refs.modalError.show();
			});
		},
		get_summary() {
			let $this = this;
			axios.get(BASE_URL + "/public/api/admin/stats/summary", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				$this.number_licenses = response.data.licenses;
				$this.number_projects = response.data.projects;
			}).catch(error => {
				$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, "
					+ "et veuillez nous excuser pour la gêne occasionnée.\nErreur : " + error;
				$this.$refs.modalError.show();
			});
		},
		get_licenses() {
			let $this = this;
			axios.get(BASE_URL + "/public/api/admin/stats/licenses", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let datas = [];
				let licenses = response.data.licenses;
				licenses.forEach(function (license) {
					datas.push({
						id: license.id,
						name: license.name,
						email_address: license.email_address,
						date_row: license.date_row.date,
						date_obj: new Date(license.date_row.date),

					});
				});
				$this.licenses = datas;
				$this.sortLicenses();
			}).catch(error => {
				$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, " +
					"et veuillez nous excuser pour la gêne occasionnée.\nErreur : " + error;
				// $this.$refs.modalError.show();
			});
		},

		// get_tickets() {
		// 	let $this = this;
		// 	axios.get("https://api.enjoyb.fr/py/form/reports", {
		// 		headers: {
		// 			"Authorization": sessionStorage.getItem("auth"),
		// 		},
		// 	})
		// 		.then(function(response) {
		// 			console.log(response.data);
		// 			let datas = [];
		// 			let tickets = response.data;
		// 			tickets.forEach(function(ticket) {
		// 				datas.push({
		// 					id: ticket.id,
		// 					name: ticket.name,
		// 					email_address: ticket.email,
		// 					state: ticket.state,
		// 					date_row: ticket.date,
		// 					date_obj: new Date(ticket.date),
		//
		// 				});
		// 			});
		// 			$this.tickets = datas;
		// 			$this.sortTickets();
		// 		}).catch(error => {
		// 			$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, " +
		// 				"et veuillez nous excuser pour la gêne occasionnée.\nErreur : " + error;
		// 			$this.$refs.modalError.show();
		// 		});
		// },

		update_state(id, state) {
			let $this = this;
			let bodyFormData = new FormData();
			bodyFormData.append("id", id);
			bodyFormData.append("state", state);
			axios.post(
				"https://horoquartz.enjoyb.net/py/form/update_report",
				bodyFormData,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).catch(error => {
				// error
				this.text_error = this.$root.$t("Errors.message_general") + error;
				$this.$refs.modalError.show();
			}).then(response => {
				let data = response.data;
				// $this.get_tickets();
			});
		},

		preview(url) {
			this.preview_path = url;
			this.$refs.previewModal.show();
		},
	},
};
</script>

<style scoped>

.admin_controls {
	margin: 24px 12px 0;
}

/*.admin_controls input {*/
/*	width: 300px;*/
/*	border: 1px solid #224B93;*/
/*}*/

.dashboard_grid {
	display: grid;
	grid-template-areas: "summary summary" "connections features";
	grid-template-columns: 1fr 1fr;
	grid-gap: 20px;
}

.cell {
	/*width: 500px;*/
}

.summary_cell {
	grid-area: summary;
}

.connections_cell {
	grid-area: connections;
}

.features_cell {
	grid-area: features;
}

.admin_videotheque {
	display: flex;
	flex-wrap: wrap;
	/*justify-content:center;*/
	margin: 0 0 24px;
}

td {
	padding: 10px 15px;
	color: var(--text-main);
}

th button {
	opacity: 0.5;
	padding: 10px;
	margin: 0;
	color: var(--text-main);
	background: none;
	border: 0;
	cursor: pointer;
	font-weight: bold;
}

th button.active {
	opacity: 1;
}

.state_static span,
.state_links button {
	padding: 5px 10px;
	border-radius: 5px;
}

.state_links button {
	background: #CCCCCC;
	color: #222222;
	border: 0;
}

.state_static .open,
.state_links .open.active {
	background: #FF8800;
	color: #FFFFFF;
}

.state_static .resolved,
.state_links .resolved.active {
	background: #00AA00;
	color: #FFFFFF;
}


</style>
